import { Flex } from 'components/shared/flex'
import { usePostTrainingContentApi, usePutTrainingContentApi } from 'api/training_content'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useContext, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { Form, useEffectSkipFirst, useForm } from 'utils/hooks'
import { ApiError } from 'utils/network/api_hooks'
import { TrainingContent, TrainingContentForm } from 'entities/training_content'

export type FormViewProps = {
    form: Form<TrainingContentForm>
    apiError: ApiError
}

const FormView = ({ form, apiError }: FormViewProps) => {
    return (
        <>
            <Flex></Flex>
        </>
    )
}

type NewTrainingContentFormProps = {
    onComplete?: () => void
}

export const NewTrainingContentForm = (props: NewTrainingContentFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePostTrainingContentApi()
    const form = useForm<TrainingContentForm>({})
    const [show, setShow] = useState<boolean>(false)

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                setShow(false)
                props.onComplete()
            }
        }
    }, [api.loading])

    const handleClose = () => {
        setShow(false)
    }

    return (
        <>
            <Button
                variant="success"
                onClick={() => {
                    setShow(true)
                }}
            >
                新規登録
            </Button>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>TrainingContentの登録</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <>
                        <FormView form={form} apiError={api.apiError} />
                    </>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        閉じる
                    </Button>
                    <Button variant="success" onClick={handleUpdate}>
                        登録
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
type EditTrainingContentFormProps = {
    trainingContent: TrainingContent
    show: boolean
    onClose: () => void
    onComplete?: () => void
}

export const EditTrainingContentForm = (props: EditTrainingContentFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePutTrainingContentApi()
    const form = useForm<TrainingContentForm>(props.trainingContent)

    useEffectSkipFirst(() => {
        form.set(props.trainingContent)
    }, [props.trainingContent])

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                props.onComplete()
            }
        }
    }, [api.loading])

    return (
        <Modal show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>TrainingContentの編集</Modal.Title>
            </Modal.Header>
            <Modal.Body>{form.object.id && <FormView form={form} apiError={api.apiError} />}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onClose}>
                    閉じる
                </Button>
                <Button variant="success" onClick={handleUpdate}>
                    更新
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
